import { render } from "./DeclinedLicensesReport.vue?vue&type=template&id=b8c67036"
import script from "./DeclinedLicensesReport.vue?vue&type=script&lang=js"
export * from "./DeclinedLicensesReport.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__